import EspecialidadeService from '@src/services/especialidade';

const especialidadeMixin = {
    data() {
        return {
            especialidadesFields: [
                {
                  key: 'descricao',
                  field: 'descricao',
                  label: 'Especialidade',
                  class: 'size-col-20',
                },
                { key: 'actions', label: '', class: 'size-col-10' },
              ],
        }
    },
    methods: {
        loadEspecialidades() { 
            let especialidades = [];

            return EspecialidadeService
                    .list()
                    .then(response => {
                        response.data.map(especialidade => especialidades.push(especialidade._doc))
                        return especialidades
                    })
                    .catch(error => error)
        },
        async findEspecialidadeById(id){
            const especialidade = await EspecialidadeService.findById(id)
            return especialidade.data
        },
        async registerEspecialidade(conveniado) {
            await EspecialidadeService.create(conveniado)
        },
        async deleteEspecialidade(id) {
            await EspecialidadeService.remove(id)
        },
        async editEspecialidade(id, especialidade) {
            await EspecialidadeService.update(id, especialidade)
        }
    }
}

export default especialidadeMixin;